import React from 'react';
import { format, parse } from 'date-fns';
import { List, ListItem } from 'telia-front-react';
import { SpecialHour } from '../../stores/BranchStore';
import { BranchOpenTime } from './BranchOpenTime';

interface BranchSpecialHoursProps {
  specialHours?: SpecialHour[];
}

export const BranchSpecialHours = (props: BranchSpecialHoursProps): React.ReactElement => {
  const { specialHours } = props;

  const slashWhenNotLast = (index: number) => {
    return specialHours.length - index > 1 ? ' / ' : '';
  };

  return (
    <List direction="inline" type="unstyled">
      <ListItem icon="#info-round">
        {sortByStartDate(specialHours).map((hour, index) => (
          <span key={index}>
            <strong>
              {formatNoYear(hour.startDate)}
              {hour.startDate !== hour.endDate && <span>-{formatNoYear(hour.endDate)} </span>}
            </strong>
            <BranchOpenTime hour={hour} displayOpenText={true} />
            {slashWhenNotLast(index)}
          </span>
        ))}
      </ListItem>
    </List>
  );
};

const formatNoYear = (date: string): string => {
  return format(parse(date, 'yyyy-MM-dd', Date.now()), 'dd.MM');
};

const sortByStartDate = (hours: SpecialHour[]): SpecialHour[] => {
  return hours.slice().sort((h1, h2) => h1.startDate.localeCompare(h2.startDate));
};
